import React from "react";

function GooglePay() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content" class="mt-20 mb-20">
              <h1>
                Google Pay <sup className="sup-reside">TM</sup>{" "}
              </h1>
              <hr />
            </section>

            <p>
              Google Pay is a wallet provider which means that Google Pay
              transfers card data securely to Safexpay and we make regular card
              transactions from that, using one of the regular acquirers.
            </p>

            <p>
              To enable Google Pay, contact your relationship manager. Note that
              when you use Google Pay you must adhere to Google's{" "}
              <a
               
                href="https://payments.developers.google.com/terms/sellertos"
                target="_blank"
              >
             <span  className="link-div">Terms of Service.</span>   
              </a>{" "}
              Once you have requested to enable the same, we will automatically
              show the Google Pay button in your payment window for applicable
              payments (Redirection Mode and JS Checkout of Safexpay page).
            </p>

            <p>
              Safexpay supports both "PAN only" and "Cryptogram 3DS" methods of
              authorization. If 3D-secure is needed for the transaction,
              Safexpay will automatically take care of that. Since some
              3D-secure authentications require the billing address of the
              customer, we recommend that you supply it to Safexpay when you
              create the payment.
            </p>

            <p>
              Safexpay supports VISA and MasterCard transactions from Google Pay{" "}
            </p>

            <p>
              Google Pay is free to use and we recommend enabling it to increase
              your conversion rate
            </p>
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </div>
  );
}
export default GooglePay;
